import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']
  
  const hasModuleAgrupaciones = store.getters['auth/hasModuleAgrupaciones']
  const hasModuleVacacionesAEAT = store.getters['auth/hasModuleVacacionesAEAT']

  const hasModuleCustomSMTPZerocoma = store.getters['auth/hasModuleCustomSMTPZerocoma']
  const hasModuleCustomSMTPCliente = store.getters['auth/hasModuleCustomSMTPCliente']
  const hasModuleCustomMails = store.getters['auth/hasModuleCustomMails']
  const hasModuleCustomLogo = store.getters['auth/hasModuleCustomLogo']
  const hasModuleCustomColors = store.getters['auth/hasModuleCustomColors']

  const hasModuleHorariosDescarga = store.getters['auth/hasModuleHorariosDescarga']
  const hasModuleCalendariosFestivosDescarga = store.getters['auth/hasModuleCalendariosFestivosDescarga']

  const hasModuleAsistenciaIA = store.getters['auth/hasModuleAsistenciaIA']
  
  // const hasModuleIntegracionAAD = store.getters['auth/hasModuleIntegracionAAD']
  // const hasModuleSAML2 = store.getters['auth/hasModuleSAML2']

  const configGrouping = {
    name: i18n.t('app.grouping'),
    path: 'configurations/grouping/companies',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }

  const configCourtesyDaysAEAT = {
    name: i18n.t('clients.courtesydaysaeat'),
    path: 'configurations/clients/courtesydaysaeat',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configPersonalization = {
    name: i18n.t('clients.personalization'),
    path: 'configurations/clients/personalization',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configHorarioDescarga = {
    name: i18n.t('clients.horario_descarga'),
    path: 'configurations/clients/downloadschedule',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configCalendariosFestivosDescarga = {
    name: i18n.t('clients.calendario_festivos'),
    path: 'configurations/clients/holidaycalendar',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configAAD = {
    name: i18n.t('clients.config_aad'),
    path: 'configurations/clients/configaad',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configSAML2 = {
    name: i18n.t('clients.config_saml2'),
    path: 'configurations/clients/configsaml2',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configAIAssist = {
    name: i18n.t('clients.ai_assist'),
    path: 'configurations/clients/configaiassist',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configHistorical = {
    name: i18n.t('app.historical'),
    path: 'configurations/clients/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }

  const menu = [
    {
      icon: 'config',
      name: i18n.t('app.clients'),
      path: 'configurations/clients',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/clients/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.modules'),
          path: 'configurations/clients/modules',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('clients.autodownload'),
        //   path: 'configurations/clients/autodownload',
        //   params,
        //   registerNavFromMenu: false,
        //   sc: [] // shorcuts
        // },
        {
          name: i18n.t('app.locations_hired'),
          path: 'configurations/clients/locations',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.template'),
          path: 'configurations/clients/template/companies',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.template_groups'),
          path: 'configurations/clients/template/groups',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('app.grouping'),
        //   path: 'configurations/grouping/companies',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.id === -1 || params.id === '-1',
        //   sc: [] // shorcuts
        // },
        // {
        //   name: i18n.t('clients.courtesydaysaeat'),
        //   path: 'configurations/clients/courtesydaysaeat',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.id === -1 || params.id === '-1',
        //   sc: [] // shorcuts
        // },
        {
          name: i18n.t('clients.representative'),
          path: 'configurations/clients/representative',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('clients.personalization'),
        //   path: 'configurations/clients/personalization',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.id === -1 || params.id === '-1',
        //   sc: [] // shorcuts
        // },
        // {
        //   name: i18n.t('app.historical'),
        //   path: 'configurations/clients/historical',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.id === -1 || params.id === '-1',
        //   sc: [] // shorcuts
        // }
      ]
    }
  ]

  if (hasModuleAgrupaciones) {
    menu[0].sc.splice(5, 0, configGrouping)
  }
  if (role !== 'AdminDistribuidor' && hasModuleVacacionesAEAT) {
    menu[0].sc.splice(6, 0, configCourtesyDaysAEAT)
  }
  if (hasModuleCustomSMTPCliente || 
    hasModuleCustomMails || 
    hasModuleCustomLogo || 
    hasModuleCustomColors || 
    (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')) {
    menu[0].sc.push(configPersonalization)
  }
  if (hasModuleHorariosDescarga) {
    menu[0].sc.push(configHorarioDescarga)
  }
  if (hasModuleCalendariosFestivosDescarga) {
    menu[0].sc.push(configCalendariosFestivosDescarga)
  }
  if (role === 'SuperAdministrador') {
    menu[0].sc.push(configAAD)
    menu[0].sc.push(configSAML2)
  }
  // if (hasModuleIntegracionAAD) {
  //   menu[0].sc.push(configAAD)
  // }
  // if (hasModuleSAML2) {
  //   menu[0].sc.push(configSAML2)
  // }
  if (hasModuleAsistenciaIA) {
    menu[0].sc.push(configAIAssist)
  }
  menu[0].sc.push(configHistorical)
  return menu
}
